export const MutationExpandMenu = 'MutationExpandMenu';
export const MutationLang = 'MutationLang';
export const MutationLoading = 'MutationLoading';
export const MutationModal = 'MutationModal';
export const MutationModalShow = 'MutationModalShow';
export const MutationPatientData = 'MutationPatientData';
export const MutationScreenSize = 'MutationScreenSize';
export const MutationSidebarControl = 'MutationSidebarControl';
export const MutationToggleDevice = 'MutationToggleDevice';
export const MutationToggleSidebar = 'MutationToggleSidebar';
export const MutationUser = 'MutationUser';
export const MutationWebSocket = 'MutationWebsocket';

